import { IImage } from '@utils/contentful/contentfulImage'
import { IProductDeliveryInfo } from 'types/contentful/productCategory'
import { useMemo, useState } from 'react'
import { BadgeAlertMessage } from '@noissue-ui-kit/badgeAlertMessage'

export const getDateFromToday = (daysToAdd: number) => {
  const futureDate = new Date()
  futureDate.setDate(new Date().getDate() + daysToAdd)
  const formattedDate = futureDate?.toDateString()?.substring(4, 10)

  return formattedDate
}

export function ProductDeliveryInfo({
  label,
  minDays,
  maxDays,
  deliveryTypeIcon,
  helpText,
  className,
}: Omit<IProductDeliveryInfo, 'deliveryTypeIcon'> & {
  deliveryTypeIcon: IImage
  className: string
}) {
  const startDate = useMemo(() => getDateFromToday(minDays), [minDays])
  const endDate = useMemo(() => getDateFromToday(maxDays), [maxDays])

  return (
    <BadgeAlertMessage
      badge={{
        url: deliveryTypeIcon?.imageUrl,
        alt: deliveryTypeIcon?.imageTitle,
      }}
      size="xs"
      borderType="square-round"
      className={className}
      variant="info"
      hintText={helpText}
      hintIcon={{
        url: '/images/product/info/eco-leafs.svg',
        alt: 'Hint Icon',
      }}
    >
      <div className="flex text-lg text-black">
        <span>{label}:&nbsp;</span>
        <span className="font-semibold">{startDate}&nbsp;-&nbsp;</span>
        <span className="font-semibold">{endDate}</span>
      </div>
    </BadgeAlertMessage>
  )
}
